import * as React from 'react';

import { IFromCommercialOwnerShieldProps } from './types';
import { ImageShield } from '../ImageShield';

export const FromCommercialOwnerShield: React.FC<IFromCommercialOwnerShieldProps> = props => {
  const { isMobile, className } = props;

  if (isMobile) {
    return <ImageShield bgc="blue" title="Собственник" className={className} />;
  }

  return <ImageShield bgc="green" title="От собственника" className={className} />;
};

FromCommercialOwnerShield.displayName = 'FromCommercialOwnerShield';
